var TableOfContents = require('./TableOfContents');
var connect = require('react-redux').connect;
var readerActions = require('../readerActions');

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    toggleTableOfContents: () =>  dispatch(readerActions.toggleTableOfContents()),
    setActiveSection: (id) => dispatch(readerActions.setActiveSection(id)),
    setHeadingPositions: (sections) => dispatch(readerActions.setHeadingPositions(sections))
  }
}

const mapStateToProps = (state) => {
  return {
    expanded: state.reader.tableOfContentsExpanded,
    sections: state.reader.sections,
    activeSectionId: state.reader.activeSectionId,
    guiLang: state.reader.readerGui.guiLang
  }
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(TableOfContents);



// WEBPACK FOOTER //
// ./src/modules/reader/components/TableOfContentsContainer.js